import { render, staticRenderFns } from "./textRound.vue?vue&type=template&id=4f77883c&scoped=true&"
import script from "./textRound.vue?vue&type=script&lang=js&"
export * from "./textRound.vue?vue&type=script&lang=js&"
import style0 from "./textRound.vue?vue&type=style&index=0&id=4f77883c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77883c",
  null
  
)

export default component.exports